import { useEffect } from "react";

/**
 * Aparición progresiva de los `.reveal` de la landing (opacity/translate en
 * globals.css). Observa los presentes al montar y, vía MutationObserver,
 * también los que monten en DIFERIDO (p. ej. las tarjetas de News, que llegan
 * tras su fetch): antes quedaban fuera del snapshot inicial y se quedaban en
 * `opacity: 0` para siempre.
 */
export function useReveal() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -60px 0px" },
    );
    document.querySelectorAll<HTMLElement>(".reveal").forEach((el) => io.observe(el));

    const mo = new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        m.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) return;
          if (node.classList.contains("reveal")) io.observe(node);
          node.querySelectorAll<HTMLElement>(".reveal").forEach((el) => io.observe(el));
        });
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });

    return () => {
      mo.disconnect();
      io.disconnect();
    };
  }, []);
}
